module.exports = __webpack_public_path__ + "static/media/jackandjill.f70d548e.jpeg";